<content-default>
    <ng-container body>
        <div class="team-overview">
            @if (isLoading) {
                <div class="team-overview__loading">
                    <p>{{ "coordinator.loadingTeams" | translate }}</p>
                </div>
            } @else if (teams.length === 0) {
                <div class="team-overview__empty">
                    <m-svg
                        iconName="user"
                        style="--icon-width: 4.8rem; --icon-height: 4.8rem; --icon-fill: var(--color-neutral400)"
                    />

                    <h2>{{ "coordinator.noTeams" | translate }}</h2>
                </div>
            } @else {
                <div class="team-overview__list">
                    @for (team of teams; track team.id) {
                        <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
                        <div
                            class="team-card"
                            (click)="selectTeam(team)"
                        >
                            <div class="team-card__header">
                                <div class="team-card__leader">
                                    <m-svg
                                        iconName="user"
                                        style="--icon-width: 2rem; --icon-height: 2rem"
                                    />

                                    <span>{{ getTeamLeader(team) }}</span>
                                </div>

                                <span class="team-card__badge">
                                    {{ getAssignmentCount(team) }}
                                    {{ "coordinator.assignments" | translate }}
                                </span>
                            </div>

                            <div class="team-card__members">
                                {{ getTeamMembers(team) }}
                            </div>

                            <div class="team-card__footer">
                                <m-svg
                                    iconName="back"
                                    style="transform: rotate(180deg); --icon-width: 1.6rem; --icon-height: 1.6rem; opacity: 0.4"
                                />
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </ng-container>
</content-default>
